import moment from "moment";

export const applyFiltersInDays = (days: any[], selectedTypeHour: any, selectedEmpresa: any, selectedMesAnio: any) => {
  return days.filter((d: any) => {
    if ((selectedTypeHour && d.tipo != selectedTypeHour) || (selectedEmpresa && d.empresa != selectedEmpresa)) return false;
    if (!Boolean(selectedMesAnio)) return false;

    const startDate = moment(selectedMesAnio, "M-YYYY").subtract(1, 'days');
    const endDate = moment(selectedMesAnio, "M-YYYY").add(1, 'months').add(1, 'days');

    return moment(d.inicio).isBetween(startDate, endDate, 'day', '[]');
  })
}